export type MailAddressState = 'unconfirmed' | 'confirmed';

export const ColorMapMailAddressState: Record<MailAddressState, ContextColor> = {
    unconfirmed: 'warning',
    confirmed: 'success',
};

export default class CustomerMailAddress {
    public id: string;
    public address: string;
    public state: MailAddressState;

    constructor(json: any) {
        this.id = json.id;
        this.address = json.address;
        this.state = (json.state ?? '').toLowerCase();
    }

    public toString(): string {
        return this.address;
    }
}
